import { inject, Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@core/ngrx-legacy';

import { TellentFeatureDiscoveryHttpClient } from './feature-discovery-http-client';
import { TellentFeatureDiscoveryActions } from './feature-discovery.store';

@Injectable({ providedIn: 'root' })
export class TellentFeatureDiscoveryEffects {
  private readonly actions$ = inject(Actions);
  private readonly featureDiscoveryHttpClient = inject(TellentFeatureDiscoveryHttpClient);
  public effect = createEffectFactory(TellentFeatureDiscoveryActions, this.actions$);

  public update$ = this.effect(TellentFeatureDiscoveryActions.update, ({ payload }) =>
    this.featureDiscoveryHttpClient.update(payload),
  );
}
